export enum ModuleType
{
    Participant,
    Push,
    Program,
    Watchlive
}